import React from 'react';
import { successUpdateMsg } from '../../../../components/atoms/const';
import Form from '../../../../components/molecules/forms';
import useAddAisle from './hooks';
import Modal from '../../../../components/organisms/modals';
import Button from '../../../../components/molecules/buttons';
import { Pencil } from '../../../../components/atoms/icons';

interface Props {
    warehouseId: number | undefined;
    isUpdate: boolean;
    refetch: () => any;
    aisleName: string | undefined;
}

function AddAisle(props: Props) {
  const {
    warehouseId, refetch, isUpdate, aisleName,
  } = props;
  const { formik, modal } = useAddAisle(warehouseId, refetch, isUpdate);

  const renderModalBody = () => {
    if (modal.result) {
      if (isUpdate) return successUpdateMsg.SUCCESS_UPDATE_AISLE;
      return successUpdateMsg.SUCCESS_ADD_NEW_AISLE;
    }
    return (
      <div>
        <Form.Default
          id="name"
          placeholder="Enter Aisle Name"
          label="Aisle Name"
          className="mb-4"
          value={formik.values.name}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.name && formik.touched.name}
          errorMsg={formik.errors.name}
          onChange={formik.handleChange}
          readOnly={isUpdate}
        />
        {!isUpdate
          ? (
            <Form.Default
              id="level"
              placeholder="Enter Level"
              label="Level"
              type="number"
              value={formik.values.level}
              onBlur={formik.handleBlur}
              isInvalid={!!formik.errors.level && formik.touched.level}
              errorMsg={formik.errors.level}
              onChange={formik.handleChange}
            />
          )
          : (
            <Form.Default
              id="newName"
              placeholder="Enter New Name"
              label="New Name"
              value={formik.values.newName}
              onBlur={formik.handleBlur}
              isInvalid={!!formik.errors.newName && formik.touched.newName}
              errorMsg={formik.errors.newName}
              onChange={formik.handleChange}
            />
          )}
      </div>
    );
  };

  return (
    <div className="w-100">
      <Modal.Default
        cancelLabel="Close"
        submitLabel="Save"
        title={isUpdate ? 'Edit Aisle' : 'Add New Aisle'}
        body={renderModalBody()}
        onSubmit={formik.handleSubmit}
        isLoading={modal.load}
        onAfterResult={modal.afterSubmit}
        result={modal.result}
        onInit={() => {
          if (aisleName) formik.setFieldValue('name', aisleName ?? '');
        }}
      >
        {!isUpdate ? (
          <Button.Default
            id="btn-addAisle"
            label="Add Aisle"
            isButton={false}
          />
        ) : (
          <div className="d-flex justify-content-end">
            <div><Pencil width={18} /></div>
          </div>
        )}
      </Modal.Default>
    </div>
  );
}

export default AddAisle;
